import "./hb-mithril.module.css";
import { html } from "lit-html";
import { getUsername } from "../../../global";

export default (user) => html`
    <form
        id="hb-mithril"
        style="${user?.phoneNumber ? "padding-bottom:2.5rem" : ""}"
        class="hidden space-y-4">
        <p
            class="mt-5 mb-3 text-center text-sm font-medium text-gray-500 dark:text-gray-400">
            <strong>FREE</strong> Humanity Proofs
            <!--via Passkey-->
        </p>
        <div
            class="w-full max-w-full p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
            <h5
                class="mb-4 text-xl font-medium text-gray-500 dark:text-gray-400">
                Heart of Mithril ℹ️
            </h5>
            <div class="flex items-baseline text-gray-900 dark:text-white">
                <span class="text-3xl font-semibold">$</span>
                <span class="text-5xl font-extrabold tracking-tight">0</span>
                <span
                    class="ms-1 text-xl font-normal text-gray-500 dark:text-gray-400"
                    >USD / month</span
                >
            </div>
            <ul role="list" class="space-y-5 my-7">
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Everything in <strong>Heart of Silver</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Blood Mithril Aura</strong> around your Beating
                        Heart</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Custom Global <strong>Username</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        Create <strong>HeartBank® Wallet</strong> (Non-Custodial
                        Wallet for Stablecoins)
                    </span>
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        Participate in <strong>Revenue Sharing</strong> based on
                        your Aura
                    </span>
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Order <strong>FREE Sample</strong> of B-Stamps</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited <strong>Check-In</strong> for Nearby
                        Discovery</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Create <strong>Family Crew</strong> Members (Custodial
                        Accounts for Minors)</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Basic <strong>Family Safety</strong> with 333℠ Sidekick
                        and On-Device History</span
                    >
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited <strong>Humanity Proofs</strong> using Passkey
                        Authentication</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited Minting and Mining of
                        <strong>Beating</strong> B-Chests with Blockchain-Level
                        Security</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited Cryptographic <strong>Cloud Safes</strong> for
                        Privacy</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited <strong>Cloud Storage</strong> of
                        <strong>B-Chests</strong> inside HeartBank® Cloud Vault
                        and HeartBank® Treasury (Aquarius™ Blockchain)</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited <strong>Cloud Storage</strong> of
                        <strong>Diamonds</strong> inside HeartBank® Trove
                        (Aquarius™ Blockchain)</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited <strong>Advanced Aquarius™ AI</strong> with
                        Chat, Voice, and Vision</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Limited <strong>Advanced</strong> AI Voice, AI Image,
                        and AI Video Generation of HeartBank® Jewels</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >24x7 Human Support via <strong>X Chat</strong> or
                        WhatsApp Chat</span
                    >
                </li>
            </ul>
            <a
                href="${user?.phoneNumber ? "#/humanity" : "#/phone"}"
                class="inline-flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 justify-center w-full text-center">
                ${user?.phoneNumber
                    ? "✅ Your Phone has been verified"
                    : "Verify Your Phone Number"}
            </a>
        </div>
        <p
            class="mt-[-5px] text-center text-xs font-medium text-gray-500 dark:text-gray-500">
            Our <strong>free quotas can change at anytime</strong> depending on
            demand and cost of operations ℹ️
        </p>
        <br />
        <div class="${user?.phoneNumber ? "" : "hidden"}">
            <label
                for="hb-mithril-username"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Your Global Username ℹ️
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="off"
                    id="hb-mithril-username"
                    class="bg-gray-50 border outline-0 border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${getUsername() || "Enter Username"}" />
                <button
                    id="hb-mithril-username-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Update
                </button>
            </section>
        </div>
        <div class="${user?.phoneNumber ? "" : "hidden"}">
            <label
                for="hb-mithril-number"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Your Phone Number
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="off"
                    id="hb-mithril-number"
                    class="bg-gray-50 border outline-0 border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${user?.phoneNumber
                        ? user.phoneNumber
                        : "+180059THANK"}"
                    disabled />
                <a
                    href="#/phone"
                    class="inline-flex items-center justify-center text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Update
                </a>
                <button
                    id="hb-mithril-number-btn"
                    type="button"
                    class="hidden text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Remove
                </button>
            </section>
        </div>
        <!--<a
            href="#/phone"
            class="hidden mt-10 w-full text-white bg-blue-500 dark:bg-blue-500 cursor-pointer focus:ring-4 focus:outline-none focus:ring-blue-500/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
            ${user?.phoneNumber
            ? "Update Your Phone Number"
            : "Verify Your Phone Number"}
        </a>
        <p
            class="hidden mt-[-5px] text-center text-xs font-medium text-gray-500 dark:text-gray-500">
            ${user?.phoneNumber
            ? ""
            : "Required for minting HeartBank® Chest with a HeartBeat"}
        </p>-->
    </form>
`;
